import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState:
    | {
        authorizedResourceAccess?: AuthorizedResourceAccessMap;
      }
    | undefined,
): AuthorizedResourceAccessMap {
  if (!initialState?.authorizedResourceAccess) {
    throw new Error('权限数据未初始化');
  }
  return initialState.authorizedResourceAccess;
}
